/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";
import {
  BsCurrencyExchange,
  BsDoorOpen,
  BsFileEarmarkPdfFill,
  BsGearWideConnected,
  BsPlug,
  BsReverseLayoutTextWindowReverse,
  BsWalletFill,
} from "react-icons/bs";
import { FaMoneyBillAlt, FaUserAlt } from "react-icons/fa";
import { FcMoneyTransfer, FcRules, FcWorkflow } from "react-icons/fc";
import { FiAlertTriangle } from "react-icons/fi";
import { GiSandsOfTime } from "react-icons/gi";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { ImUpload, ImUsers } from "react-icons/im";
import { IoIosCreate } from "react-icons/io";
import {
  MdAccountBalanceWallet,
  MdOutlineAccountBalance,
  MdOutlineHistory,
  MdPayment,
  MdPending,
  MdRequestPage,
  MdSettings,
  MdSupportAgent,
} from "react-icons/md";
import { SiKnown } from "react-icons/si";
import { VscVerified } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import cashSvg from "../../assets/images/svgs/cash.svg";
import document from "../../assets/images/svgs/document.svg";
import peopleSvg from "../../assets/images/svgs/people.svg";
import reportSvg from "../../assets/images/svgs/report.svg";
import transferSvg from "../../assets/images/svgs/transfer.svg";
import walletSvg from "../../assets/images/svgs/wallet.svg";
import {
  menuInitialStatus,
  menuType,
  userTypes,
} from "../../utils/helpers/constants";
import { getBaseUrl } from "../../utils/services/baseUrl";

function PayOutMenu({ active, menu, domainBrand, profile }) {
  const dropDownInitState = menuInitialStatus;
  const [dropDownStatus, updateDropDownStatus] = useState(dropDownInitState);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const reboundNav = (event, id) => {
    event.preventDefault();
    expandMenu(id);
  };

  const expandMenu = (idName) => {
    const dropDownData = { ...dropDownInitState, [idName]: true };
    updateDropDownStatus(dropDownData);
  };

  const domainUrl = getBaseUrl();

  useEffect(() => {
    expandMenu(menu);
  }, [menu]);
  return (
    <>
      {/* MANAGER */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/api-transaction-report"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EXTERNAL_PARTY_PAYO_189399001"]
                  : "External Party Pay-out"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/unlock-transaction"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_UNLOCK_TRANSACTIO_-1638858905"]
                  : "Unlock Transaction"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* MANAGEMENT */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.MANAGEMENT ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "partner/agent" ? "active" : ""}>
              <NavLink
                exact
                to="/management/partner-agents"
                className="slide-item"
              >
                <FaUserAlt fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_trading_partners"]
                  : "Partners/Agents/Branches"}
              </NavLink>
            </li>

            <li className={active === "app/disapprove" ? "active" : ""}>
              <NavLink
                exact
                to="/management/approve-disapprove-agent"
                className="slide-item"
              >
                <FaUserAlt fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_P_36761235"]
                  : "Approve/Disapprove Agents"}
              </NavLink>
            </li>

            <li className={active === "administrators" ? "active" : ""}>
              <NavLink
                exact
                to="/management/administrators"
                className="slide-item"
              >
                <FaUserAlt fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["para_pay_center_admins"]
                  : "Administrators"}
              </NavLink>
            </li>

            <li className={active === "employees" ? "active" : ""}>
              <NavLink exact to="/management/employees" className="slide-item">
                <GrUserWorker fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EMPLOYEE_-1048133672"]
                  : "Employees"}
              </NavLink>
            </li>

            <li className={active === "app/dis/cashier" ? "active" : ""}>
              <NavLink
                exact
                to="/management/approve-disapprove-cashier"
                className="slide-item"
              >
                <FaUserAlt fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                  : "Approve/Disapprove Cashier Profiles"}
              </NavLink>
            </li>

            <li className={active === "import" ? "active" : ""}>
              <NavLink
                exact
                to="/management/bulk-upload"
                className="slide-item"
              >
                <ImUpload fontSize={20} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_load_data_from_file"]
                  : "Import Data From File"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* SETTINGS */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SETTINGS)}
            exact
            to="/settings"
            className={menu === menuType.SETTINGS ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Settings
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.SETTINGS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "workflow" ? "active" : ""}>
              <NavLink to="/settings/workflow" className="slide-item">
                <FcWorkflow color={"#6259CA"} fontSize={20} fill={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_WORKFLO_-434837466"]
                  : "Workflow"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* PLUGIN/API */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.PLUGIN_API)}
            exact
            to="/plugins/payout-api/add-payout-api"
            className={menu === menuType.PLUGIN_API ? "active" : ""}
          >
            <BsPlug color={"#6259CA"} fontSize={23} /> &nbsp;{" "}
            {dictionary ? dictionary["WO_PLUGINSAP_-161147171"] : "Plugins/API"}
            &nbsp;
            
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.PLUGIN_API]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "plugin" ? "active" : ""}>
              <NavLink
                to="/plugins/payout-api/add-payout-api"
                className="slide-item"
              >
                <BsPlug color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ADD_NEW_PLUGI_1498103904"]
                  : "Add Pay-out API"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CASHIER */}
      {/* REPORTS */}
      {/* {profile.userType === userTypes.CASHIER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus ? dictionary["title_payout"] : "Payout"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CUSTOMER */}
      {/* BRANCH_ADMIN */}
      {/* REPORTS */}
      {/* {profile.userType === userTypes.BRANCH_ADMIN ||
      profile.userType === userTypes.AGENTS ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EXTERNAL_PARTY_PAYO_189399001"]
                  : "External Party Pay-out"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_UNLOCK_TRANSACTIO_-1638858905"]
                  : "Unlock Transaction"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* MANAGEMENT */}
      {/* {profile.userType === userTypes.BRANCH_ADMIN ||
      profile.userType === userTypes.AGENTS ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EMPLOYEE_-1048133672"]
                  : "Employees"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                  : "Approve/Disapprove Cashier Profiles"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_load_data_from_file"]
                  : "Import Data From File"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}
    </>
  );
}

export default PayOutMenu;

// Quick actions needs to only include pay-out
